import React from "react";
import { isWeekend } from "date-fns";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import getId from "../../../../utils/getId";
import { GDANSK_KIND_SINGLE_TICKET } from "../Steps/gdanskSaleStepsConsts";

interface IProps {
  form: GdanskSaleForm;
}

export const GdanskExerciseWeekendRule: React.FC<IProps> = ({ form }) => {
  if (form.kind !== GDANSK_KIND_SINGLE_TICKET || !form.date || !isWeekend(form.date)) {
    return null;
  }
  if (!getId(form.exercise)) {
    return null;
  }
  const html = form.exercise.description?.trim();
  if (!html) {
    return null;
  }

  return (
    <div className="gdansk-exercise-weekend-rule" role="region" aria-label="Zasady obowiązujące przy wybranym terminie">
      <div className="gdansk-exercise-weekend-rule__body" dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
};
